import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'

import { IconButton, ICON_TYPES, Divider } from '@st-operations/uikit/src/v2/index.js'

import { useCollapsibleElement } from '_hooks'

import './styles.scss'

const Collapsible = React.forwardRef(
  (
    {
      className,
      title,
      children,
      onOpenClick,
      showOpenButton,
      onDeleteAllClick,
      showDeleteAllButton,
      managedState,
      headerAddon,
      hideToggle,
      disabled,
    },
    ref
  ) => {
    const { isOpen, collapsibleHeight, collapsibleRef, toggleCollapsible } = useCollapsibleElement(
      [children],
      true,
      managedState
    )

    return (
      <section ref={ref} className={classNames('collapsible', className)}>
        <header className="collapsible__header-container">
          <h1
            className={classNames('collapsible__header', {
              'opacity-50': disabled,
            })}
          >
            {title}
          </h1>
          <If condition={headerAddon}>
            <div className="mr-2">{headerAddon}</div>
          </If>
          <If condition={showOpenButton}>
            <IconButton
              className="collapsible__header-button"
              text="Settings"
              onClick={onOpenClick}
              iconProps={{ icon: 'settings', type: 'outline' }}
            />
          </If>
          <If condition={showDeleteAllButton}>
            <IconButton
              className="collapsible__header-button"
              text="Delete All"
              onClick={onDeleteAllClick}
              iconProps={{ icon: 'trashcan', type: 'outline' }}
            />
          </If>
          <If condition={!hideToggle}>
            <Divider vertical className="collapsible__divider" />
            <IconButton
              iconProps={{
                icon: 'angledown',
                type: ICON_TYPES.OUTLINE,
                width: '24px',
                height: '24px',
              }}
              onClick={toggleCollapsible}
              ariaLabel={`${isOpen ? 'hide' : 'show'} destination fields`}
              classes={{
                icon: classNames('collapsible__icon-collapsible', {
                  'collapsible__icon-collapsible--open': isOpen,
                }),
                button: 'collapsible__button-collapsible',
              }}
            />
          </If>
        </header>
        <div
          style={{ maxHeight: collapsibleHeight }}
          ref={collapsibleRef}
          className={classNames('collapsible__content', {
            'collapsible__content--open': isOpen,
          })}
          aria-hidden={!isOpen}
        >
          {children}
        </div>
      </section>
    )
  }
)

Collapsible.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
  onOpenClick: PropTypes.func,
  showOpenButton: PropTypes.bool,
  headerAddon: PropTypes.func,
}

Collapsible.defaultProps = {
  title: '',
  onOpenClick: () => {},
  showOpenButton: true,
}

Collapsible.displayName = 'Collapsible'

export default Collapsible
